import { render, staticRenderFns } from "./NotificationLikeButton.vue?vue&type=template&id=50742a22&"
import script from "./NotificationLikeButton.vue?vue&type=script&lang=js&"
export * from "./NotificationLikeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports